import type { FormConfig } from './types'

export const instituteSearchForm: FormConfig = {
  id: 'instituteSearch',
  submitLabel: { de: 'Abschicken', en: 'Send' },
  successMessage: {
    de: 'Vielen Dank, Ihre Anfrage wurde erfolgreich versendet.',
    en: 'Thank you, your request has been sent successfully.',
  },
  fields: [
    {
      id: 'name',
      type: 'text',
      label: { de: 'Name', en: 'Name' },
    },
    {
      id: 'email',
      type: 'email',
      label: { de: 'E-Mail-Adresse', en: 'E-Mail Address' },
      required: true,
    },
    {
      id: 'phone',
      type: 'text',
      label: { de: 'Telefonnummer', en: 'Phone' },
    },
    {
      id: 'zip',
      type: 'text',
      label: { de: 'PLZ', en: 'ZIP code' },
      required: true,
    },
    {
      id: 'message',
      type: 'textarea',
      label: { de: 'Mitteilung', en: 'Message' },
      required: true,
    },
  ],
  consentField: {
    id: 'agreeWithPersonalDataProcessing',
    type: 'checkbox',
    required: true,
    label: {
      de: 'Ich bin mit der Speicherung und Verarbeitung der hier angegebenen personenbezogenen Daten einverstanden. Die Daten werden allein zum Zwecke der Kontaktaufnahme durch Mitarbeiter der "MALU WILZ Beaute GmbH" auf Grundlage unserer Datenschutzerklärung erhoben.',
      en: 'I agree to the storage and processing of the personal data given here. The data is collected solely for the purpose of establishing contact by employees of "MALU WILZ Beaute GmbH" on the basis of our data protection declaration.',
    },
  },
}
